import Countries from 'data/CountriesDialCodes.json'

window.onload = function() {
  const jsci = document.getElementById('jsci')
  if (jsci) {
    jsci.value = 'green'
  }

  window.uid = getUID()
  const uid = document.getElementById('uid')
  if (uid) {
    uid.value = window.uid
  }
}

function capitalizeAndReplace(s) {
  if (typeof s !== 'string') return ''
  s = s.charAt(0).toUpperCase() + s.slice(1)
  return s.replace('-', ' ')
}

// Step Form Logic for Signup
const signUpForm = document.querySelector('.form-wrapper')
const stepOne = document.querySelector('#step-one')
const stepTwo = document.querySelector('#step-two')
const continueBtn = document.querySelector('#continue-btn')
const emailInput = document.querySelector('#email')
const passwordInput = document.querySelector('#password')
const togglePassword = document.querySelector('#togglePassword')
const stepOneInputs = [...document.querySelectorAll('.form-input')].slice(0, 3)
const phoneNumber = document.getElementById('phone')
const searchInput = document.querySelector('#search-input')
const allCountires = document.querySelectorAll('.options-wrapper.countires .option')
const backBtn = document.querySelector('#back-btn')
const propertyTypeInput = document.querySelector('#propertyType')
const accommodationUnitsInput = document.querySelector('#accommodationUnits')
const countryInput = document.querySelector('#country')
const createAccountButton = document.querySelector('#createAccountButton')
const termsToggle = document.querySelector('#termsCheckbox')
const invitationCreateAccountButton = document.querySelector('#invitationCreateAccountButton')
const invitationNameInput = document.querySelector('#fullName')

window.addEventListener('DOMContentLoaded', () => {
  if (backBtn !== null) {
    backBtn.addEventListener('click', e => {
      e.preventDefault()
      stepTwo.classList.remove('active')
      stepOne.classList.add('active')
      signUpForm.parentNode.classList.remove('active-second-step')
    })
  }
  if (termsToggle !== null) {
    termsToggle.addEventListener('click', () => {
      setCreateAccountButtonStatus()
    })
  }

  if (propertyTypeInput !== null && propertyTypeInput.value !== '') {
    document.querySelector('#selectedPropertyType').textContent = capitalizeAndReplace(propertyTypeInput.value)
    if (propertyTypeInput.value === 'Hostel') {
      document.querySelector('#isHostel').textContent = window.accomodationTranslations.numberOfBeds
    }
  }

  if (accommodationUnitsInput !== null && accommodationUnitsInput.value !== '') {
    document.querySelector('#selectedAccommodationUnits').textContent = accommodationUnitsInput.value
  }

  if (countryInput !== null && countryInput.value !== '') {
    const selectedCountry = Countries.find(country => country.code === countryInput.value)
    document.querySelector('#selectedCountry').textContent = selectedCountry.name
    document.querySelector('.call-number').textContent = selectedCountry.dial_code
  }
})

function checkIsEmpty() {
  let isDisabled = stepOneInputs.some(input => {
    if (input.name === 'fullName') {
      let countWords = input.value?.match(/\S+/g)?.length
      return countWords < 2 || !input.value
    }
    return !input.value
  })

  continueBtn.disabled = isDisabled
}

function isPasswordValid() {
  return passwordInput.value?.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{12,}$/g)?.length > 0
}

function isEmailValid() {
  return emailInput.value?.match(/^\S+@\S+\.\S+$/g)?.length > 0
}

function validateInputs() {
  if (!isEmailValid() || !isPasswordValid()) {
    if (!isPasswordValid()) {
      passwordInput.parentNode.parentNode.classList.add('error')
      passwordInput.parentNode.parentNode.querySelector('.error-box').removeAttribute('hidden')
    }

    if (!isEmailValid()) {
      emailInput.parentNode.classList.add('error')
      emailInput.parentNode.querySelector('.error-box').removeAttribute('hidden')
    }
    return false
  }

  return true
}

function refreshEmailError() {
  if (isEmailValid()) {
    emailInput.parentNode.classList.remove('error')
    emailInput.parentNode.querySelector('.error-box').setAttribute('hidden', true)
  }
}

function refreshPasswordError() {
  if (isPasswordValid()) {
    passwordInput.parentNode.parentNode.classList.remove('error')
    passwordInput.parentNode.parentNode.querySelector('.error-box').setAttribute('hidden', true)
  }
}

if (stepOne !== null) {
  stepOne.addEventListener('input', checkIsEmpty)
}

if (continueBtn !== null) {
  continueBtn.addEventListener('click', e => {
    e.preventDefault()

    if (validateInputs()) {
      stepOne.classList.remove('active')
      stepTwo.classList.add('active')
      signUpForm.parentNode.classList.add('active-second-step')

      passwordInput.removeEventListener('keyup', refreshPasswordError)
      emailInput.removeEventListener('keyup', refreshEmailError)
    } else {
      passwordInput.addEventListener('keyup', refreshPasswordError)
      emailInput.addEventListener('keyup', refreshEmailError)
    }
  })
}

// Toggle Password Visibility
if (togglePassword !== null) {
  togglePassword.addEventListener('click', () => {
    const getAttrType = passwordInput.getAttribute('type')
    if (getAttrType === 'password') {
      return passwordInput.setAttribute('type', 'text')
    }

    passwordInput.setAttribute('type', 'password')
  })
}

// Polyfil for .closest()
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this

    do {
      if (Element.prototype.matches.call(el, s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

// Custom Select Dropdowns actions
for (const dropdown of document.querySelectorAll('.custom-select-wrapper')) {
  dropdown.addEventListener('click', function(e) {
    this.querySelector('.custom-select').classList.toggle('open')
    searchInput.focus()
    if (e.target.contains(searchInput)) {
      this.querySelector('.custom-select').classList.add('open')
    }
  })
}

for (const option of document.querySelectorAll('.option')) {
  option.addEventListener('click', function() {
    const parentSelectWrapper = this.parentNode.parentNode.parentNode

    if (!this.classList.contains('selected')) {
      this.parentNode.querySelector('.option.selected').classList.remove('selected')
    }

    this.classList.add('selected')
    this.closest('.custom-select').querySelector('.trigger span').textContent = this.textContent

    if (this.classList.contains('country')) {
      document.querySelector('.call-number').textContent = this.dataset.dialcode
    }

    if (this.classList.contains('property-type')) {
      document.querySelector('#propertyType').value = this.dataset.value
      if (this.dataset.value === 'Hostel') {
        document.querySelector('#isHostel').textContent = window.accomodationTranslations.numberOfBeds
        return
      }
      document.querySelector('#isHostel').textContent = window.accomodationTranslations.accomodationUnits
    }

    if (this.classList.contains('accommodation-units')) {
      document.querySelector('#accommodationUnits').value = this.dataset.value
    }

    if (this.classList.contains('country')) {
      document.querySelector('#country').value = this.dataset.value
      resetAllCountriesList()
    }

    if (parentSelectWrapper.parentNode.classList.contains('error')) {
      parentSelectWrapper.parentNode.classList.remove('error')
    }

    setCreateAccountButtonStatus()
  })
}

if (phoneNumber !== null) {
  phoneNumber.addEventListener('change', function() {
    this.parentNode.parentNode.classList.remove('error')
  })
  phoneNumber.addEventListener('keyup', function() {
    setCreateAccountButtonStatus()
  })
}

if (passwordInput !== null && invitationCreateAccountButton !== null) {
  passwordInput.addEventListener('keyup', function() {
    setCreateAccountButtonStatus()
  })
}

if (invitationNameInput !== null && invitationCreateAccountButton !== null) {
  invitationNameInput.addEventListener('keyup', function() {
    setCreateAccountButtonStatus()
  })
}

if (searchInput !== null) {
  searchInput.addEventListener('keyup', function(e) {
    filterList(e.target.value)
  })
}

function setCreateAccountButtonStatus() {
  // case for invitation
  if (invitationCreateAccountButton !== null) {
    if (termsToggle.checked && passwordInput.value && invitationNameInput.value?.match(/\S+/g)?.length > 1) {
      invitationCreateAccountButton.disabled = false
    } else {
      invitationCreateAccountButton.disabled = true
    }
    // case for normal signup
  } else {
    if (
      propertyTypeInput.value &&
      accommodationUnitsInput.value &&
      countryInput.value &&
      phoneNumber.value &&
      termsToggle.checked
    ) {
      createAccountButton.disabled = false
    } else {
      createAccountButton.disabled = true
    }
  }
}

function filterList(searchTerm) {
  searchTerm = searchTerm.toLowerCase()

  allCountires.forEach(option => {
    let label = option.innerText.toLowerCase()
    if (label.indexOf(searchTerm) !== -1) {
      option.style.display = 'block'
    } else {
      option.style.display = 'none'
    }
  })
}

function resetAllCountriesList() {
  searchInput.value = ''

  allCountires.forEach(option => {
    option.style.display = 'block'
  })
}

window.addEventListener('click', e => {
  for (const select of document.querySelectorAll('.custom-select')) {
    if (!select.contains(e.target)) {
      select.classList.remove('open')
      resetAllCountriesList()
    }
  }
})

function getUID() {
  let uid = getGUIDFromCookie('rga')
  if (!uid) {
    uid = generateUID()
    setCookie('rga', uid, 365)
  }

  return uid
}

function getGUIDFromCookie(cookieName) {
  let value = document.cookie.match(`(^|;) ?${cookieName}=([^;]*)(;|$)`)
  return value ? value[2] : null
}

function generateUID() {
  let str = ''
  for (let i = 0; i < 6; i++) {
    str += Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return str
}

function setCookie(cname, cvalue, exdays) {
  let domain = app.mainDomain || 'rentl.io'
  let d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  let expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;domain=' + domain
}
